<template>
    <form id="find-tour"
          action="#"
          @submit.prevent="">

        <div class="form-item relative">
            <input type="text"
                   name="name"
                   @click="clearFormErrors('name')"
                   class="form-control"
                   :placeholder="Lang.get('common.name')"
                   v-model="form.name"
            >
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('name')"
                  v-text="'Поле Ім\'я є обов\'язковим для заповнення.'">
            </span>
        </div>

        <div class="form-item relative">
            <input type="text"
                   name="phone"
                   class="form-control mobilephone-input-mask"
                   @click="clearFormErrors('phone')"
                   :placeholder="Lang.get('common.phone')"
                   v-model="form.phone"
            >
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('phone')"
                  v-text="'Поле Телефон є обов\'язковим для заповнення.'">
            </span>
        </div>


        <div class="form-item relative select">
            <select v-model="form.country"
                    name="country">
                <option value="selected">Летимо в</option>
                <option v-for="country in countries">{{ country }}</option>
            </select>
        </div>

        <input class="btn btn-success"
               type="submit"
               @click="onSubmit"
               :disabled="isDisabled"
               :value="Lang.get('common.send_header')">
        <widget-loading v-if="form.loading" color="#000"></widget-loading>

    </form>
</template>

<script>
    import WidgetLoading from '../elements/WidgetLoading';

    export default {
        name: "find-tour",
        props: {
            countries: {
                required: true,
                type: Array
            }
        },
        components: {
            WidgetLoading,
        },
        data() {
            return {
                form: new Form({
                    name: '',
                    phone: '',
                    email: '',
                    country: 'selected',
                    type: 'find_tour',
                    url: location,
                }),
                isDisabled: false,
                Lang,
            }
        },
        methods: {
            clearFormErrors(name) {
                this.form.errors.clear(name);
                if (!this.form.errors.any()) {
                    this.isDisabled = false;
                }
            },
            onSubmit() {
                let vm = this;
                this.isDisabled = true;
                this.form.post('/find-tour').then(res => {
                    vm.isDisabled = false;

                    //document.querySelector('#find-tour').innerHTML = res;
                    let result = document.querySelectorAll('.form-findTour-id');
                    for (let i = 0; i < document.querySelectorAll('.form-findTour-id').length; i++) {
                        result[i].innerHTML = res;
                    }
                }).catch(error => console.log(error));

            },
        },
        mounted() {
            helpers.setInputMask('mobilephone');
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/forms/FindTour.vue